import React from 'react'

import { Text } from '@mxenabled/mxui'

import type { SxProps, Theme } from '@mui/material'
import MuiCardHeader from '@mui/material/CardHeader'

export interface CardHeaderMUIProps {
  menuActionElement?: React.ReactNode
  hasFullWidthImage?: boolean
  isMini?: boolean
  subHeader?: React.ReactNode
  sx?: SxProps<Theme>
  title: string
}

export const CardHeaderMUI: React.FC<CardHeaderMUIProps> = ({
  menuActionElement = null,
  hasFullWidthImage = false,
  isMini = false,
  subHeader,
  sx = {},
  title,
}) => {
  return (
    <MuiCardHeader
      action={menuActionElement}
      subheader={subHeader}
      sx={{
        alignItems: 'flex-start',
        gap: 4,
        p: 0,
        ...(!subHeader && { height: 24 }),
        ...(hasFullWidthImage && { ...(isMini ? { mb: 16 } : { px: 16, pt: 16, mb: 0 }) }),
        ...sx,
      }}
      title={
        <Text
          dangerouslySetInnerHTML={{ __html: title }}
          sx={isMini ? { letterSpacing: 0.35 } : {}}
          variant="h3"
        />
      }
    />
  )
}
